import adjustment from './adjustment'
import date from './date'
import reason from './reason'
import memo from './memo'
import inventoryLocation from './inventoryLocation'
import transactionId from './transactionId'

export default function getColumns( hasMultipleStores?: boolean ) {
	return [
		date,
		...hasMultipleStores ? [ inventoryLocation ] : [],
		reason,
		adjustment,
		memo,
		transactionId,
	]
}
